import React from 'react';

export const Footer: React.FC = () => {
    return (
        <footer className="bg-[#050911] border-t border-white/5 py-12 px-6">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">

                {/* --- SECCIÓN LOGO --- */}
                <div className="flex items-center gap-2">
                    <img
                        src="/logo.png"
                        alt="GamesNewsJR Logo"
                        className="w-8 h-8 object-contain"
                    />
                    <span className="text-slate-400 font-medium">juniorztwo © {new Date().getFullYear()} pagina sin fines de lucro </span>
                </div>

                {/* --- SECCIÓN LINKS (Con tu web personal en Contacto) --- */}
                <div className="flex gap-8 text-sm text-slate-500">
                    {/* Link actualizado a tu web personal */}
                    <a
                        href="https://juniorztwo.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-white transition-colors"
                    >
                        Contacto y mi pagina web
                    </a>
                </div>

                {/* --- SECCIÓN REDES SOCIALES --- */}
                <div className="flex items-center gap-3">
                    {/* Texto añadido */}
                    <span className="text-xs font-medium text-slate-500 uppercase tracking-wide">
                        visita mi instagram
                    </span>

                    {/* Botón Instagram */}
                    <a
                        href="https://www.instagram.com/juniorztwo/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-8 h-8 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center cursor-pointer transition-colors group"
                        aria-label="Instagram"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="text-slate-400 group-hover:text-white transition-colors"
                        >
                            <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                            <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                        </svg>
                    </a>
                </div>
            </div>
        </footer>
    );
};